(() => {
  const supportsFinePointer = window.matchMedia('(pointer: fine)').matches;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!supportsFinePointer || reduceMotion) return;

  document.querySelectorAll('[data-mbx-tilt]').forEach((card) => {
    let frame;
    const update = (event) => {
      const rect = card.getBoundingClientRect();
      const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
      const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        card.classList.add('is-tracking');
        card.style.setProperty('--mbx-rx', `${(0.5 - y) * 7}deg`);
        card.style.setProperty('--mbx-ry', `${(x - 0.5) * 9}deg`);
        card.style.setProperty('--mbx-mx', `${(0.5 - x) * 14}px`);
        card.style.setProperty('--mbx-my', `${(0.5 - y) * 10}px`);
        card.style.setProperty('--mbx-shadow-x', `${(0.5 - x) * 22}px`);
        card.style.setProperty('--mbx-shadow-y', `${26 + y * 18}px`);
      });
    };
    const reset = () => {
      cancelAnimationFrame(frame);
      card.classList.remove('is-tracking');
      ['--mbx-rx', '--mbx-ry', '--mbx-mx', '--mbx-my', '--mbx-shadow-x', '--mbx-shadow-y'].forEach((name) => card.style.removeProperty(name));
    };
    card.addEventListener('pointermove', update, { passive: true });
    card.addEventListener('pointerleave', reset, { passive: true });
  });
})();
